import { render } from "./SingleValueUserResult.vue?vue&type=template&id=0c961eb1"
import script from "./SingleValueUserResult.vue?vue&type=script&lang=js"
export * from "./SingleValueUserResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__